// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-tooltip{position:absolute;top:0;left:0;border:1px solid #000;border-radius:3px;padding:4px;font-size:12px;background:#fff;white-space:nowrap;pointer-events:none}", ""]);
// Exports
module.exports = exports;
